import { Controller, useFormContext } from 'react-hook-form'

import { FF2, SecuredInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

type AccountNumberProps = {
  index: number
}

export const AccountNumber = ({ index }: AccountNumberProps) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`transactionsInfo.${index as 0}.accountNumber`}
      control={control}
      rules={{ validate: (value) => Validators.required.notEmpty(value) }}
      render={({ field }) => (
        <FF2
          required
          field={field}
          label="Bank Account Number"
          input={(props) => <SecuredInput {...props} data-lpignore={true} data-qa="Bank Account Number" />}
        />
      )}
    />
  )
}
